import {
  ICONS,
  PLATFORM_THEME_COLORS,
  Button,
  ButtonsWrapper,
} from '@thinknet-gmbh/platform-common-ui';

const BoxExpandButtons = ({
  createElement,
  createButtonTxt,
  canEdit,
}: {
  createElement: () => void;
  createButtonTxt: string;
  canEdit: boolean;
}) => {
  return (
    <ButtonsWrapper>
      {!canEdit ? (
        <Button
          type="primary"
          ghost
          icon={ICONS.plus}
          onClick={createElement}
          iconColor={PLATFORM_THEME_COLORS.primary.blue}
        >
          {createButtonTxt}
        </Button>
      ) : (
        <Button
          type="primary"
          ghost
          icon={ICONS.edit}
          onClick={createElement}
          iconColor={PLATFORM_THEME_COLORS.primary.blue}
        >
          {createButtonTxt}
        </Button>
      )}
    </ButtonsWrapper>
  );
};

export default BoxExpandButtons;
